import { Directive, ElementRef, inject, Input, OnInit } from '@angular/core';

import { FeatureFlagName, FeatureFlagService } from 'app/shared/services/feature-flag.service';

@Directive({
  selector: '[khRemoveIfFeatureOff]',
  standalone: false
})
export class RemoveIfFeatureOffDirective implements OnInit {
  private element = inject(ElementRef);
  private readonly featureFlagService = inject(FeatureFlagService);

  @Input('khRemoveIfFeatureOff') public featureName!: FeatureFlagName;

  public ngOnInit(): void {
    if (this.featureFlagService.isFeatureOff(this.featureName)) {
      this.element.nativeElement.parentNode.removeChild(this.element.nativeElement);
    }
  }
}
